import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { handleLogout } from "containers/Login/reducer";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import LookerSettingsModalContainer from "containers/LookerSettings/LookerSettingsModal";

import * as lookerSettingsReducer from "containers/LookerSettings/reducer";

class LookerSetupContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return <LookerSettingsModalContainer />;
  }
}

const mapDispatchToProps = (dispatch) => ({});

const mapStateToProps = (state) => ({});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(LookerSetupContainer);
